export default class CouponReference {
  static async retrieve(axios, id) {
    const response = await axios.post(
      '/graphql/',
      `query {
        referenceCouponRetrieve(id: ${id}) {
          id
          totalPerUser
          active          
          coupon {
            id
            title
            deal {
              id
              name
            }
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );
    response.data.data.referenceCouponRetrieve.compressed = {
      coupon: response.data.data.referenceCouponRetrieve.coupon   
    };  
    response.data.data.referenceCouponRetrieve.deal = response.data.data.referenceCouponRetrieve.coupon.deal.id;  
    response.data.data.referenceCouponRetrieve.coupon = response.data.data.referenceCouponRetrieve.coupon.id;

    return response.data.data.referenceCouponRetrieve;
  }

  static async all(axios) {
    const response = await axios.post(
      '/graphql/',
      `query {
        referenceCouponList {
          results {
            id
            coupon {
              id
              title
            }
            totalPerUser
            active
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.referenceCouponList.results.reverse();
  }

  static async filter(axios, active) {
    const response = await axios.post(
      '/graphql/',
      `query{
        referenceCouponList(active: ${active}) {
          results {
            id
            coupon {
              id
              title
            }
            totalPerUser
            active
          }
        }
      }`,
      {
        headers: {
          'Content-Type': 'application/graphql'
        }
      }
    );

    return response.data.data.referenceCouponList.results.reverse();
  }

  static async delete(axios, id) {
    const response = await axios.post(
      '/graphql/', {
        query: `mutation deleteReferenceCoupon($id: ID!) {
          deleteReferenceCoupon(id: $id){
            ok
          }
        }`,
        variables: {
          "id": id
        }
      },
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data.data.deleteReferenceCoupon.ok;
  }

}